<template>
     <div class="card fill-height">
        <div class="pb-3 radius-sm d-flex align-items-center">
            <i class="icon icon-clock text-fuchsia me-2 fs-2"></i>
            <span class=" text-fuchsia b-700">Haftalık Çalışılan Süre</span>
        </div>
        <div class="d-flex flex-column align-items-start align-items-xl-center p-2">
            <div class="text-center">
                <h4>{{ appData.fn.getHour(max) }} Saat</h4>
                <DonutChart :value="getTime" :text="appData.fn.getHour(value) + '<br>SAAT'" font-color="#9a3ca8" font-size="1.2rem" empty-color="#efefef" fill-color="#fb1185, #9b2bac, #d02ee9, #9a3ca8" :size="size" strong="4rem"></DonutChart>
            </div>
        </div>
    </div>
</template>
<script>
    import { reactive, toRefs, computed } from "vue";
    import { appData, C } from "@/helpers/global";

    import DonutChart from "@/components/chart/DonutChart.vue";
    
    export default {
        name: "WeeklyWorkingTimeChart",
        components:{
            DonutChart,
        },
        props: {
            modelValue: {
                type: Number,
                default: 0
            },
            size: {
                default: "13rem",
            },
            max: {
                type: Number,
                default: 10  
            },
        },
        emits: ["update:modelValue"],
        setup(props, ctx) {            
            const e = reactive({
                value: computed({
                    get() {
                        return props.modelValue;
                    },
                    set(value) {
                        ctx.emit("update:modelValue", value);
                    }
                }),
                getTime: computed(() => {
                    let val = e.value;
                    //if (val > e.max) {
                    //    val = e.max;
                    //}
                    return (C.Dec(val) / (props.max)) * 100;
                }),
                list: {
                },
            });
            return { ...toRefs(e) };
        }
    };
</script>
<style scoped>
</style>
